/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { lazy, type ComponentType, type LazyExoticComponent } from "react";

type Pages = Record<string, ComponentType<any>>;

/**
 * One lazy boundary per page module: every page named through the returned accessor comes from
 * the same chunk, loaded once on the first route that needs it.
 */
export function lazyPages<M extends Pages>(load: () => Promise<M>) {
  return <K extends keyof M & string>(name: K): LazyExoticComponent<M[K]> =>
    lazy(() => load().then(module => ({ default: module[name] })));
}
